import React from 'react';
import { CardHeader, Col, Row } from 'reactstrap';

interface InfoPanelHeaderProps {
	title: React.ReactNode;
	segments?: React.ReactNode[];
	trailing?: React.ReactNode;
}

const InfoPanelHeader = ({ title, segments = [], trailing }: InfoPanelHeaderProps) => (
	<CardHeader className="PatientInfoCardHeader">
		<Row className="align-items-baseline">
			<Col lg="auto" style={{ paddingLeft: 0 }}>
				<h4>{title}</h4>
			</Col>
			{segments.map((segment, index) => (
				<React.Fragment key={index}>
					{index > 0 && (
						<Col lg="auto" style={{ padding: '0px 3px' }}>
							<h5>&#8226;</h5>
						</Col>
					)}
					<Col lg="auto" style={{ padding: 0 }}>
						<h6>{segment}</h6>
					</Col>
				</React.Fragment>
			))}
			{trailing && (
				<Col className="ms-auto text-end">
					{trailing}
				</Col>
			)}
		</Row>
	</CardHeader>
);

export default InfoPanelHeader;
